import { defineStore } from 'pinia'
import secureStorage from '@/utils/secure-storage'
let persist: any = true
if (process.client) {
  const storage = secureStorage()
  if (storage) {
    persist = {
      storage
    }
  }
}
export default defineStore('userConfig', {
  persist,
  state: () => {
    return {
      user: {} as { [key: string]: any },
      group: {} as { [key: string]: any },
      workspaces: [] as { [key: string]: any }[],
      isAdmin: false as Boolean,
      isDriver: false as Boolean,
      isCompanyAdmin: false as Boolean,
      companyTypes: [] as string[],
      avatar: null as string | null,
      logo: null as string | null,
      page: '' as string
    }
  },
  actions: {
    addWorkspace: function (payload: any) {
      if (!payload) {
        return
      }
      if (!Array.isArray(this.workspaces)) {
        this.workspaces = []
      }
      this.workspaces.push(payload)
    },
    setUser: function (payload: any) {
      this.user = payload
    },
    setGroup: function (payload: any) {
      this.group = payload
    },
    setAvatar: function (payload: any) {
      this.avatar = payload || null
    },
    setLogo: function (payload: any) {
      this.logo = payload || null
    },
    setPage: function (payload: any) {
      if (!['PARTNER', 'OWNER', 'ADMINCP'].includes(payload)) {
        this.page = ''
        return
      }

      this.page = payload
    },
    setIsDriver: function (payload: any) {
      this.isDriver = payload || false
    }
  },
  getters: {
    getUser: (state: any) => state.user,
    getGroup: (state: any) => state.group,
    getAvatar: (state: any) => state.avatar,
    getLogo: (state: any) => state.logo,
    getPage: (state: any) => state.page,
    getIsDriver: (state: any) => {
      return state.isDriver
    }
  }
})
